import { InjectionFeature, RewardFeatures, type RewardFormState } from '@/common/reward/types';
import { computed, reactive, ref, watch } from 'vue';

const DEFAULT_REWARD_FEATURE = InjectionFeature.AvatarBundle;

export function useRewardForm<T extends RewardFormState>(initialModel: T) {
    const feature = ref<InjectionFeature | number>(initialModel.feature ?? DEFAULT_REWARD_FEATURE);

    const rewardItem = computed(() => RewardFeatures.find(item => item.value === feature.value));
    const quantityLabel = computed(() => rewardItem.value?.quantityLabel ?? 'Quantity');
    const dataLabel = computed(() => rewardItem.value?.dataLabel ?? 'ItemId');
    const canEditData = computed(() => rewardItem.value?.canEditData ?? false);
    const canEditQuantity = computed(() => rewardItem.value?.canEditQuantity ?? false);

    const model = reactive({
        ...initialModel,
        feature,
        dataLabel,
        quantityLabel,
        canEditData,
        canEditQuantity
    });

    watch(feature, () => {
        model.quantity = 1;
        model.data = 0;
    });

    return { feature, model };
}
